import React from "react";
import { motion } from "framer-motion";
import { useDesktopMotion } from "@/lib/responsive";

// Lightweight scroll-reveal wrapper using framer-motion.
export const Reveal = ({ children, delay = 0, className = "", as = "div", ...rest }) => {
  const animate = useDesktopMotion();
  if (!animate) {
    const Tag = as;
    return <Tag className={className} {...rest}>{children}</Tag>;
  }
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: [0.21, 0.47, 0.32, 0.98] }}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
